export enum ReasonsEnum {
  AGE_AND_FACE = 'AGE&FACE',
  INSURANCE_LABS = 'INSURANCE_LABS',
  APPLICATION = 'APPLICATION',
  TRL = 'TRL',
  RX = 'RX',
  MIB = 'MIB',
  MVR = 'MVR',
  APS = 'APS',
  ETI = 'ETI',
  EHR = 'EHR',
  MEDEXAM = 'MEDEXAM',
  CRIMINAL_RECORDS = 'CRIMINAL_RECORDS',
  MEDICAL_CLAIMS = 'MEDICAL_CLAIMS',
  LABPIQTURE = 'LABPIQTURE',
  EHR_INSUFFICIENT = 'EHR_INSUFFICIENT',
}

export interface Reason {
  displayName: string;
  key: ReasonsEnum;
}

export class ReasonsTransform {
  private static reasonsMap: Map<ReasonsEnum, Reason> = new Map([
    [
      ReasonsEnum.AGE_AND_FACE,
      {
        displayName: 'Age & Face',
        key: ReasonsEnum.AGE_AND_FACE,
      },
    ],
    [
      ReasonsEnum.INSURANCE_LABS,
      {
        displayName: 'Insurance Labs',
        key: ReasonsEnum.INSURANCE_LABS,
      },
    ],
    [
      ReasonsEnum.APPLICATION,
      {
        displayName: 'Application',
        key: ReasonsEnum.APPLICATION,
      },
    ],
    [ReasonsEnum.TRL, { displayName: 'TRL', key: ReasonsEnum.TRL }],
    [ReasonsEnum.RX, { displayName: 'Rx', key: ReasonsEnum.RX }],
    [ReasonsEnum.MIB, { displayName: 'MIB', key: ReasonsEnum.MIB }],
    [ReasonsEnum.MVR, { displayName: 'MVR', key: ReasonsEnum.MVR }],
    [ReasonsEnum.APS, { displayName: 'APS', key: ReasonsEnum.APS }],
    [ReasonsEnum.ETI, { displayName: 'ETI', key: ReasonsEnum.ETI }],
    [ReasonsEnum.EHR, { displayName: 'EHR', key: ReasonsEnum.EHR }],
    [ReasonsEnum.MEDEXAM, { displayName: 'Labs', key: ReasonsEnum.MEDEXAM }],
    [
      ReasonsEnum.CRIMINAL_RECORDS,
      { displayName: 'Criminal Records', key: ReasonsEnum.CRIMINAL_RECORDS },
    ],
    [
      ReasonsEnum.MEDICAL_CLAIMS,
      { displayName: 'Medical Claims', key: ReasonsEnum.MEDICAL_CLAIMS },
    ],
    [
      ReasonsEnum.LABPIQTURE,
      { displayName: 'LabPiQture', key: ReasonsEnum.LABPIQTURE },
    ],
    [
      ReasonsEnum.EHR_INSUFFICIENT,
      { displayName: 'EHR Insufficient', key: ReasonsEnum.EHR_INSUFFICIENT },
    ],
  ]);

  public static getReason(key: string) {
    return this.reasonsMap.get(key as ReasonsEnum);
  }

  public static getReasonDisplay(key: string): string {
    const reason = this.reasonsMap.get(key as ReasonsEnum);
    if (reason) {
      return reason.displayName;
    }
    return 'NA';
  }
}
